import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import MainFiltersBQ from "../../Global/Models/Filters/MainFiltersBQ";
import VotingFacade from "./Facade/VotingFacade";
import PotmUserVotesFilters from "./Models/PlayerOfTheMatch/Filters/PotmUserVotesFilters";
import PollsFilters from "./Models/Polls/Filters/PollsFilters";

export default class Voting {
  private facade: VotingFacade = null;

  constructor(config: SDKConfigurationModel) {
    this.facade = new VotingFacade(config);
  }

  public getPolls = async (filters?: PollsFilters, disableCache?: boolean) => {
    return await this.facade.getPolls(filters, disableCache);
  };

  public getPollById = async (pollId: string, disableCache?: boolean) => {
    return await this.facade.getPollById(pollId, disableCache);
  };

  public voteForPoll = async (pollId: string, optionId: string | string[]) => {
    return await this.facade.voteForPoll(pollId, optionId);
  };

  public deleteVoteForPoll = async (pollId: string) => {
    return await this.facade.deleteVoteForPoll(pollId);
  };

  public getMyPollVote = async (pollId: string, showModels?: boolean) => {
    return await this.facade.getMyPollVote(pollId, showModels);
  };

  public getMyPollsVotes = async (filters?: MainFiltersBQ) => {
    return await this.facade.getMyPollsVotes(filters);
  };

  public voteForPlayerOfTheMatch = async (
    matchId: string,
    playerId: string
  ) => {
    return await this.facade.voteForPlayerOfTheMatch(matchId, playerId);
  };

  public deleteVoteForPlayerOfTheMatch = async (matchId: string) => {
    return await this.facade.deleteVoteForPlayerOfTheMatch(matchId);
  };

  public getOwnVotesForPlayerOfTheMatch = async (filters?: PotmUserVotesFilters) => {
    return await this.facade.getOwnVotesForPlayerOfTheMatch(filters);
  };

  public getResultsForPlayerOfTheMatch = async (
    matchId: string,
    disableCache?: boolean
  ) => {
    return await this.facade.getResultsForPlayerOfTheMatch(
      matchId,
      disableCache
    );
  };
}
